(function () {
    var pixelsTag = document.querySelector('div.pixels');
    var progressTag = document.querySelector("div.progress");
    var bodyTag = document.querySelector("body");
    var sections = document.querySelectorAll('div.section');
    var headerTag = document.querySelector('header');
    var clientTag = document.querySelector('div.client');
    var pageTag = document.querySelector('div.parallax');
    if (pageTag) {
        console.log(pageTag);
        document.addEventListener('scroll', function () {
            var topViewport = window.pageYOffset;
            var midViewport = topViewport + (window.innerHeight / 2);
            sections.forEach(function (section) {
                // @ts-ignore
                var midSection = section.offsetTop + (section.offsetHeight / 2);
                var distanceToSection = midViewport - midSection;
                var parallaxTags = section.querySelectorAll('[data-parallax]');
                parallaxTags.forEach(function (tag) {
                    var ratio = parseFloat(tag.getAttribute('data-parallax'));
                    var weightedDistance = distanceToSection * ratio;
                    // @ts-ignore
                    tag.style.transform = "translate(0, " + weightedDistance + "px)";
                });
            });
        });
    }
})();
